module.exports = __webpack_public_path__ + "static/media/multisequences.5630ba23.jpeg";